import { useEffect, useState } from "react";
import { useAlertMessageContext } from "../../../contexts/alert-message.context";
import { useConfirmMessageContext } from "../../../contexts/confirm-message.context";
import { useTranslateContext } from "../../../contexts/translate.context";
import { usePartnerContext } from "../../../contexts/partner.context";
import { isEmpty } from "../../../utilities/validators";
import { AlertMessageEnum, getServantType, ServantType } from "../../../utilities/types";
import authService from "../../../services/auth.service";
import cndService from "../../../services/cnd.service";
import { Card, Col, Container, Form, FormControl, FormGroup, Image, Row, Spinner, Tab, Tabs } from "react-bootstrap";
import { dateToString, idade, toLowerCase, toUpperCase } from "../../../utilities/auxiliary-functions";
import { FaEdit, FaSave, FaTrash } from "react-icons/fa";
import ImageLightBox from "../../../components/image-lightbox/ImageLightbox";
import { Tooltip as TooltipMaterial } from '@mui/material';
import { Button } from '@mui/material'
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

import styles from './estate-all-condominium-form.module.scss';
import FileResizer from "react-image-file-resizer";
import CondominiumHeader from "../../headers/condominium.header";
import AddressRecord from "../../records/address.record";
import AddIcon from '@mui/icons-material/Add';

import './estate-all-condominium-form.scss';
import ResidentCadastreModal from "../../modals/resident.cadastre.modal";
import VehicleCadastreModal from "../../modals/vehicle.cadastre.modal";
import ServantCadastreModal from "../../modals/servant.cadastre.modal";
import VisitorCadastreModal from "../../modals/visitor.cadastre.modal";
import { cpfCnpjMask, phoneMask, removeMask, zipcodeMask } from "../../../utilities/masks";
import lclService from "../../../services/lcl.service";
import EstateVesselCadastreModal from "../../modals/estate-vessel.cadastre.modal";

export interface IEstateAllCondominiumFormProps {
    title: string,
    identifier: string,
    setRecord?: any,
    viewOnly?: boolean,
    tabView: string,
}

export const EstateAllCondominiumForm: React.FC<IEstateAllCondominiumFormProps> = (props: IEstateAllCondominiumFormProps) => {

    const alertContext = useAlertMessageContext();
    const confirmContext = useConfirmMessageContext();
    const { display } = useTranslateContext();
    let { partner } = usePartnerContext();

    const [ invalidatedForm, setInvalidatedForm ] = useState(false);
    const [ isEditForm, setEditForm ] = useState(false);

    let reloadPage = false;
    const [ isLoading, setLoading ] = useState(false);
    const [ originRecord, setOriginRecord ] = useState({} as any);
    const [ sending, setSending ] = useState(false);
    const [ isEditRecord, setEditRecord ] = useState(true);

    const [ estateId, setEstateId ] = useState(0);
    const [ name, setName ] = useState('');
    const [ registration, setRegistration ] = useState('');
    const [ association, setAssociation ] = useState(0);
    const [ image, setImage ] = useState('');
    // Address
    const [ addressId, setAddressId ] = useState(0);
    const [ zipcode, setZipcode ] = useState('');
    const [ state, setState ] = useState('');
    const [ city, setCity ] = useState('');
    const [ district, setDistrict ] = useState('');
    const [ place, setPlace ] = useState('');
    const [ habitation, setHabitation ] = useState('');
    const [ complement, setComplement ] = useState('');

    const [ showResident, setShowResident ] = useState(false);
    const [ residents, setResidents ] = useState([] as any);
    const [ resident, setResident ] = useState({} as any);

    const [ showVehicle, setShowVehicle ] = useState(false);
    const [ vehicles, setVehicles ] = useState([] as any);
    const [ vehicle, setVehicle ] = useState({} as any);

    const [ showServant, setShowServant ] = useState(false);
    const [ servants, setServants ] = useState([] as any);
    const [ servant, setServant ] = useState({} as any);

    const [ showVisitor, setShowVisitor ] = useState(false);
    const [ visitors, setVisitors ] = useState([] as any);
    const [ visitor, setVisitor ] = useState({} as any);

    const [ showEstateVessel, setShowEstateVessel ] = useState(false);
    const [ estateVessels, setEstateVessels ] = useState([] as any);
    const [ estateVessel, setEstateVessel ] = useState({} as any);

    function fillRecord(estate: any) {

        if (!isEmpty(estate)) {
            setEstateId(estate.id);
            setName(estate.name);
            setRegistration(estate.registration);
            setAssociation(estate.association);
            setImage(estate.image);
            
            if (!isEmpty(estate.address)) {
                setAddressId(estate.addressId);
                setZipcode(zipcodeMask(estate.address.zipcode));
                setState(estate.address.state);
                setCity(estate.address.city);
                setDistrict(estate.address.district);
                setPlace(estate.address.place);

                setHabitation(estate.habitation);
                setComplement(estate.complement);
            }
        }
    } // fillRecord

    async function isValidForm() {
        let result = true;
        let emptyRequired = false;

        if (isEmpty(name))
            emptyRequired = true;
        if (isEmpty(registration))
            emptyRequired = true;
        if (isEmpty(association))
            emptyRequired = true;
        if (isEmpty(zipcode))
            emptyRequired = true;
        if (isEmpty(state))
            emptyRequired = true;
        if (isEmpty(city))
            emptyRequired = true;
        if (isEmpty(district))
            emptyRequired = true;
        if (isEmpty(place))
            emptyRequired = true;
        if (isEmpty(habitation))
            emptyRequired = true;

        if (emptyRequired) {
            await alertContext.show(AlertMessageEnum.FAIL, props.title, display.message.invalid.required);
            result = false;
        }

        setInvalidatedForm(!result);
        return result;
    } // isValidForm

    async function searchParam() {
        try {
            setEditForm(!props.viewOnly);
            if (!Number.isNaN(Number.parseInt(props.identifier ||''))) {

                const estate = await cndService.estateById(Number(props.identifier));
                if (estate) {
                    setOriginRecord(estate);
                    fillRecord(estate);

                    cndService.residentByEstate(estate.id).then((result: any) => {
                        setResidents(result.rows);
                    });
                    cndService.vehicleByEstate(estate.id).then((result: any) => {
                        setVehicles(result.rows);
                    });
                    cndService.servantByEstate(estate.id).then((result: any) => {
                        const servants = [] as any;
                        for ( let i = 0; i < result.rows.length; i++) {
                            const servant = result.rows[i];
                            const weekly = JSON.parse(servant.journey);
                            servants.push({
                                caste: servant.caste,
                                estateId: servant.estateId,
                                id: servant.id,
                                journey: weekly,
                                nickname: servant.nickname,
                                partnerId: servant.partnerId,
                                people: servant.people,
                                peopleId: servant.peopleId,
                                situation: servant.situation
                            });
                        }
                        setServants(servants);
                    });
                    cndService.visitorByEstate(estate.id).then((result: any) => {
                        setVisitors(result.rows);
                    });
                    cndService.vesselByEstate(estate.id).then(async (result: any) => {
                        const estateVessels = [] as any;
                        for ( let i = 0; i < result.rows.length; i++) {
                            const estateVessel = result.rows[i];
                            estateVessel.vessel.image = await lclService.vesselImageById(Number(estateVessel.vesselId));
                            estateVessels.push({
                                estateId: estateVessel.estateId,
                                observation: estateVessel.observation,
                                partnerId: estateVessel.partnerId,
                                vessel: estateVessel.vessel,
                                vesselId: estateVessel.vesselId,
                            });
                        }
                        setEstateVessels(estateVessels);
                    });
                } else 
                    clearEstate();
            } else
                clearEstate();
        } catch(error: any) {
            await alertContext.show(AlertMessageEnum.FAIL, props.title, error);
        }
    } // searchParam

    function fillRegister() {

        const address = {
            id : addressId,
            zipcode : removeMask(zipcode),
            state : state,
            city : city,
            district : district,
            place : place
        };

        const dataResidents = [] as any;
        for (let r = 0; r < residents.length; r++) {
            const resident = residents[r];
            resident.people.adresses[0].address = address;
            resident.people.adresses[0].correspondence = 1;
            resident.people.adresses[0].norm = 'residential';
            resident.people.adresses[0].habitation = habitation;
            resident.people.adresses[0].complement = complement;
            dataResidents[dataResidents.length] = resident;
        }

        const dataEstate = {
            id: estateId,
            name,
            registration,
            association,
            image,
            partnerId : partner.id,
            addressId : addressId,
            address,
            habitation,
            complement
            // residents: dataResidents,
            // servants: dataServants,
            // visitors: dataVisitors
        };

        return dataEstate;
    } // fillRegister

    function clearEstate() {

        setEstateId(0);
        setName('');
        setRegistration('');
        setAssociation(0);
        setImage('');
        // Address
        setAddressId(0);
        setZipcode('');
        setState('');
        setCity('');
        setDistrict('');
        setPlace('');
        setHabitation('');
        setComplement('');
        // Others
        setResidents([] as any);
        setResident({} as any);
        setVehicles([] as any);
        setVehicle({} as any);
        setServants([] as any);
        setServant({} as any);
        setVisitors([] as any);
        setVisitor({} as any);
        setEstateVessels([] as any);
        setEstateVessel({} as any);
    }

    function onClick_CancelEstate(event: any) {
        event.preventDefault();
        
        clearEstate();
        if (props.setRecord)
            props.setRecord(event, 0);
    } // onClick_CancelEstate

    async function onClick_SaveEstate(event: any) {
        event.preventDefault();
        
        const isValid = await isValidForm();
        if (isValid) {
            try {
                const isConfirmed = await confirmContext.show(props.title, display.message.confirm_record);
                if (isConfirmed) {
                    setSending(true);

                    let estate = fillRegister();
                    if (estate.id > 0)
                        estate = await cndService.saveEstate(estate.id, estate);
                    else
                        estate = await cndService.createEstate(estate);

                    for (let i = 0; i < residents.length; i++) {
                        const resident = residents[i];
                        resident.estateId = estate.id;
                        if (resident.id > 0)
                            await cndService.saveResident(resident.id, resident);
                        else
                            await cndService.createResident(resident);
                    }

                    for (let i = 0; i < vehicles.length; i++) {
                        const vehicle = vehicles[i];
                        vehicle.estateId = estate.id;
                        if (vehicle.id > 0)
                            await cndService.saveVehicle(vehicle.id, vehicle);
                        else
                            await cndService.createVehicle(vehicle);
                    }

                    for (let i = 0; i < servants.length; i++) {
                        const servant = servants[i];
                        servant.estateId = estate.id;
                        if (servant.id > 0)
                            await cndService.saveServant(servant.id, servant);
                        else
                            await cndService.createServant(servant);
                    }

                    for (let i = 0; i < visitors.length; i++) {
                        const visitor = visitors[i];
                        for (let j = 0; j < visitor.recurrences.length; j++)
                            visitor.recurrences[j].estateId = estate.id;
                        if (visitor.id > 0)
                            await cndService.saveVisitor(visitor.id, servant);
                        else
                            await cndService.createVisitor(visitor);
                    }

                    setSending(false);
                    await alertContext.show(AlertMessageEnum.SUCCESS, props.title, display.message.the_record_has_been_saved_successfully);
                    if (props.setRecord)
                        props.setRecord(event, 0);
                }
            } catch (error: any) {
                setSending(false);
                await alertContext.show(AlertMessageEnum.FAIL, props.title, error);
            }
        }
    } // onClick_SaveEstate

    function onClick_AddResident(event: any) {
        event.preventDefault();
        setShowResident(true);
        setEditForm(false);
    }

    function onClick_EditResident(event: any, record: any) {
        event.preventDefault();
        setResident(record);
        setShowResident(true);
        setEditForm(true);
    }

    async function onClick_DeleteResident(event: any, position: number) {
        event.preventDefault();
        const resident = structuredClone(residents[position]);
        
        const isConfirm = await confirmContext.show(props.title, `Deseja remover o morador ( ${resident.nickname} ) ?`);
        if (isConfirm) {
            try {
                residents.splice(position, 1);
                setResidents(residents);
                await cndService.residentDeleteById(Number(resident.id));
                await alertContext.show(AlertMessageEnum.SUCCESS, props.title, `Morador removido  ${ resident.nickname } com sucesso !!!`);
            } catch (error: any) {
                await alertContext.show(AlertMessageEnum.FAIL, props.title, error.message);
            }
        }
    }

    function onClick_AddVehicle(event: any) {
        event.preventDefault();
        setShowVehicle(true);
        setEditForm(false);
    }

    function onClick_EditVehicle(event: any, record: any) {
        event.preventDefault();
        setVehicle(record);
        setShowVehicle(true);
        setEditForm(true);
    }

    async function onClick_DeleteVehicle(event: any, position: number) {
        event.preventDefault();
        const vehicle = structuredClone(vehicles[position]);
        
        const isConfirm = await confirmContext.show(props.title, `Deseja remover o veículo ( ${vehicle.mark} - ${vehicle.model} ) ?`);
        if (isConfirm) {
            try {
                vehicles.splice(position, 1);
                setVehicles(vehicles);
                await cndService.vehicleDeleteById(Number(vehicle.id));
                await alertContext.show(AlertMessageEnum.SUCCESS, props.title, `Veículo removido  ${vehicle.mark} - ${vehicle.model} com sucesso !!!`);
            } catch (error: any) {
                await alertContext.show(AlertMessageEnum.FAIL, props.title, error.message);
            }
        }
    }

    function onClick_AddServant(event: any) {
        event.preventDefault();
        setShowServant(true);
        setEditForm(false);
    }

    function onClick_EditServant(event: any, record: any) {
        event.preventDefault();
        setServant(record);
        setShowServant(true);
        setEditForm(true);
    }

    async function onClick_DeleteServant(event: any, position: number) {
        event.preventDefault();
        const servant = structuredClone(servants[position]);
        
        const isConfirm = await confirmContext.show(props.title, `Deseja remover o prestador ( ${servant.nickname} ) ?`);
        if (isConfirm) {
            try {
                servants.splice(position, 1);
                setServants(servants);
                await cndService.servantDeleteById(Number(servant.id));
                await alertContext.show(AlertMessageEnum.SUCCESS, props.title, `Prestador removido  ${ servant.nickname } com sucesso !!!`);
            } catch (error: any) {
                await alertContext.show(AlertMessageEnum.FAIL, props.title, error.message);
            }
        }
    }

    function onClick_AddVisitor(event: any) {
        event.preventDefault();
        setShowVisitor(true);
        setEditForm(false);
    }

    function onClick_EditVisitor(event: any, record: any) {
        event.preventDefault();
        setVisitor(record);
        setShowVisitor(true);
        setEditForm(true);
    }

    async function onClick_DeleteVisitor(event: any, position: number) {
        event.preventDefault();
        const visitor = structuredClone(visitors[position]);
        
        const isConfirm = await confirmContext.show(props.title, `Deseja remover o visitante ( ${visitor.nickname} ) ?`);
        if (isConfirm) {
            try {
                visitors.splice(position, 1);
                setVisitors(visitors);
                await cndService.visitorDeleteById(Number(visitor.id));
                await alertContext.show(AlertMessageEnum.SUCCESS, props.title, `Visitante removido  ${ visitor.nickname } com sucesso !!!`);
            } catch (error: any) {
                await alertContext.show(AlertMessageEnum.FAIL, props.title, error.message);
            }
        }
    }

    function onClick_AddEstateVessel(event: any) {
        event.preventDefault();
        setShowEstateVessel(true);
        setEditForm(false);
    }

    function onClick_EditEstateVessel(event: any, record: any) {
        event.preventDefault();
        setEstateVessel(record);
        setShowEstateVessel(true);
        setEditForm(true);
    }

    async function onClick_DeleteEstateVessel(event: any, position: number) {
        event.preventDefault();
        const estateVessel = structuredClone(estateVessels[position]);
        
        const isConfirm = await confirmContext.show(props.title, `Deseja remover a embarcação ( ${estateVessel.vessel.name} ) ?`);
        if (isConfirm) {
            try {
                estateVessels.splice(position, 1);
                setEstateVessels(estateVessels);
                await cndService.vesselDeleteById(Number(estateVessel.vesselId));
                await alertContext.show(AlertMessageEnum.SUCCESS, props.title, `Embarcação removido  ${ estateVessel.vessel.name } com sucesso !!!`);
            } catch (error: any) {
                await alertContext.show(AlertMessageEnum.FAIL, props.title, error.message);
            }
        }
    }

    useEffect(() => {
        if (!isLoading && !reloadPage) {
            if (isEmpty(partner))
                // eslint-disable-next-line react-hooks/exhaustive-deps
                partner = authService.currentPartner();

            searchParam();
        }

        return () => {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            reloadPage = !reloadPage;
        }
    }, []); // useEffect

    function onChange_Image(event: any) {
        event.preventDefault();

        if (event.target.files && event.target.files.length > 0) {
            /*
            let reader = new FileReader();
            reader.onload = (e: any) => {
                setImage(e.target.result);
            };
            reader.readAsDataURL(event.target.files[0]);
            */
            const file = event.target.files[0];
            FileResizer.imageFileResizer(file, 300, 300, "JPEG", 100, 0,
                (uri: any) => {
                    setImage(uri);
                }, "base64"
            );
        } else {
            setImage('');
        }
    }

    function viewCadastreForm() {

        return (
            <Container fluid className="page-body EstateAll">
                <Row>
                    <Col sm={12} className="page-sweet">
                        <Card>
                            <Card.Header>
                                {(originRecord?.created || originRecord?.updated) && (
                                    <div className="form-identy-registry float-right">
                                        <span className="white-space"><b>Criação: </b> {dateToString(originRecord.created, 'dd/mm/yyyy HH:MM:ss')}</span>
                                        <span className="white-space"><b>Atualização: </b> {dateToString(originRecord.updated, 'dd/mm/yyyy HH:MM:ss')}</span>
                                    </div>
                                )}
                                <Card.Title>{display.legend.record}</Card.Title>
                            </Card.Header>
                            <Card.Body>
                                <Form className="form" id="form-cadastre" validated={invalidatedForm}>
                                    <Row>
                                        <Col sm="4">
                                            <div className="d-flex flex-column align-items-center">
                                                <ImageLightBox containerStyle={styles.imageWrapperVessel} src={image} alt="Imóvel" />
                                                {!props.viewOnly && <FormGroup as={Row} className={`mt-2 d-flex justify-content-start ${styles.imageControls}`}>
                                                    <label htmlFor='input-file-image'>
                                                        <TooltipMaterial className="isClickable" title="Fazer upload de nova foto">
                                                            <CloudUploadIcon />
                                                        </TooltipMaterial>
                                                    </label>
                                                    <label className="text-right" onClick={(e)=> onChange_Image(e)}>
                                                        <TooltipMaterial className="isClickable ms-2" title="Remover foto atual">
                                                            <HighlightOffIcon />
                                                        </TooltipMaterial>
                                                    </label>
                                                    <Form.Control type='file' id='input-file-image' accept="image/*" onChange={(e)=> onChange_Image(e)} />
                                                </FormGroup>}
                                            </div>
                                        </Col>
                                        <Col sm="8">
                                            <Row>
                                                <Col sm="7">
                                                    <FormGroup>
                                                        <Form.Label htmlFor="form-name">{display.label.name}</Form.Label>
                                                        <FormControl id="form-name" name="name" placeholder={display.example.name}
                                                            disabled={!isEditRecord}
                                                            value={name}
                                                            onChange={e => setName(e.target.value)}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                                <Col sm="3">
                                                    <FormGroup>
                                                        <Form.Label htmlFor="form-registration">{display.label.registration}</Form.Label>
                                                        <FormControl id="form-registration" name="registration" placeholder={display.example.registration}
                                                            disabled={!isEditRecord}
                                                            value={registration}
                                                            onChange={e => setRegistration(toUpperCase(e.target.value))}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                                <Col sm="2" style={{ margin: 'auto' }} >
                                                    <span className="react-switch-description white-space">{display.label.association}</span>
                                                    <div className="react-switch">
                                                        <FormControl type="checkbox" className="react-switch-checkbox" id="form-association" name="association" 
                                                            disabled={!isEditRecord}
                                                            checked={association === 1}
                                                            onChange={(e) => setAssociation(association === 1 ? 0 : 1)}
                                                        />
                                                        <Form.Label className="react-switch-label" htmlFor="form-association">
                                                            <span className={`react-switch-button`} /> 
                                                        </Form.Label>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col sm="12">
                                                    <AddressRecord
                                                        title={props.title}
                                                        isEdit={isEditRecord}
                                                        identifier={props.identifier === ''}
                                                        viewOnly={props.viewOnly} 

                                                        zipcode={zipcode}
                                                        state={state}
                                                        city={city}
                                                        district={district}
                                                        place={place}
                                                        habitation={habitation}
                                                        complement={complement}
                                                        setZipcode={(value: any) => { setZipcode(value); }} 
                                                        setState={(value: any) => { setState(value); }} 
                                                        setCity={(value: any) => { setCity(value); }} 
                                                        setDistrict={(value: any) => { setDistrict(value); }} 
                                                        setPlace={(value: any) => { setPlace(value); }} 
                                                        setHabitation={(value: any) => { setHabitation(value); }} 
                                                        setComplement={(value: any) => { setComplement(value); }}

                                                        attachment={false}
                                                    />
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <hr />
                                    <Row>
                                        <Col sm="12">
                                            <Container fluid className="container-min">
                                                <Tabs defaultActiveKey={association === 1 ? 'estate-servant' : props.tabView} id="tabs-estate" className="mb-3">
                                                    {association === 0 && <Tab eventKey="estate-resident" title={'Moradores'}>
                                                        <Container fluid className="container-min">
                                                            <fieldset>
                                                                <legend className="d-flex justify-content-between align-items-center pt-2 px-2">
                                                                    <span>Listagem de Moradores</span>
                                                                    <Button onClick={ (e) => onClick_AddResident(e) } variant="contained" color="primary">
                                                                        <AddIcon />Adicionar
                                                                    </Button>
                                                                </legend>
                                                                <ul className='resident-list'>
                                                                    {residents?.map((resident: any, index: number) => (
                                                                        <li className='resident-item' key={`resident-item-${index}`}>
                                                                            <div className='resident-item-img'>
                                                                                <Image src={resident.people?.image} />
                                                                            </div>
                                                                            <div className='resident-item-data'>
                                                                                <div>
                                                                                    <div className='resident-item-datafield'><strong>Apelido:</strong>{resident.nickname}</div>
                                                                                </div>
                                                                                <div>
                                                                                    <div className='resident-item-datafield'><strong>Nome:</strong>{resident.people ? resident.people.fullname : ''}</div>
                                                                                    <div className='resident-item-datafield'><strong>Telefone:</strong>{resident.people ? phoneMask(resident.people.phones[0].connection) : ''}</div>
                                                                                    <div className='resident-item-datafield'><strong>Idade:</strong>{resident.people ? dateToString(new Date(resident.people.birth), 'dd/mm/yyyy') : ''} - {resident.people ? idade(new Date(resident.people.birth)) : ''} anos</div>
                                                                                </div>
                                                                                <div>
                                                                                    <div className='resident-item-datafield'><strong>CPF:</strong>{resident.people ? cpfCnpjMask(resident.people.registrationPf) : ''}</div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="resident-item-action">
                                                                                <TooltipMaterial className="isClickable" title="Editar">
                                                                                    <span onClick={(e) => onClick_EditResident(e, resident)}>
                                                                                        <FaEdit size={18} />
                                                                                    </span>
                                                                                </TooltipMaterial>
                                                                                <TooltipMaterial className="isClickable" title="Excluir">
                                                                                    <span onClick={(e) => onClick_DeleteResident(e, index)}>
                                                                                        <FaTrash size={18} />
                                                                                    </span>
                                                                                </TooltipMaterial>
                                                                            </div>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            </fieldset>
                                                        </Container>
                                                    </Tab>}
                                                    {association === 0 && <Tab eventKey="estate-vehicle" title={'Veículos'}>
                                                        <Container fluid className="container-min">
                                                            <fieldset>
                                                                <legend className="d-flex justify-content-between align-items-center pt-2 px-2">
                                                                    <span>Listagem de Veículos</span>
                                                                    <Button onClick={ (e) => onClick_AddVehicle(e) } variant="contained" color="primary">
                                                                        <AddIcon />Adicionar
                                                                    </Button>
                                                                </legend>
                                                                <ul className='vehicle-list'>
                                                                    {vehicles?.map((vehicle: any, index: number) => (
                                                                        <li className='vehicle-item' key={`resident-item-${index}`}>
                                                                            <div className='vehicle-item-img'>
                                                                                <Image src={vehicle.image} />
                                                                            </div>
                                                                            <div className='vehicle-item-data'>
                                                                                <div>
                                                                                    <div className='vehicle-item-datafield'><strong>Marca:</strong>{vehicle.mark}</div>
                                                                                    <div className='vehicle-item-datafield'><strong>Modelo:</strong>{vehicle.model}</div>
                                                                                    <div className='vehicle-item-datafield'><strong>Cor:</strong>{vehicle.colorName}</div>
                                                                                    <div className='vehicle-item-datafield'><strong>Ano:</strong>{vehicle.manufacture}</div>
                                                                                    <div className='vehicle-item-datafield'><strong>Placa:</strong>{vehicle.plate}</div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="vehicle-item-action">
                                                                                <TooltipMaterial className="isClickable" title="Editar">
                                                                                    <span onClick={(e) => onClick_EditVehicle(e, vehicle)}>
                                                                                        <FaEdit size={18} />
                                                                                    </span>
                                                                                </TooltipMaterial>
                                                                                <TooltipMaterial className="isClickable" title="Excluir">
                                                                                    <span onClick={(e) => onClick_DeleteVehicle(e, index)}>
                                                                                        <FaTrash size={18} />
                                                                                    </span>
                                                                                </TooltipMaterial>
                                                                            </div>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            </fieldset>
                                                        </Container>
                                                    </Tab>}
                                                    {association === 0 && <Tab eventKey="estate-vessel" title={'Embarcações'}>
                                                        <Container fluid className="container-min">
                                                            <fieldset>
                                                                <legend className="d-flex justify-content-between align-items-center pt-2 px-2">
                                                                    <span>Listagem de Embarcações</span>
                                                                    <Button onClick={ (e) => onClick_AddEstateVessel(e) } variant="contained" color="primary">
                                                                        <AddIcon />Adicionar
                                                                    </Button>
                                                                </legend>
                                                                <ul className='vessel-list'>
                                                                    {estateVessels?.map((estateVessel: any, index: number) => (
                                                                        <li className='vessel-item' key={`vessel-item-${index}`}>
                                                                            <div className='vessel-item-img'>
                                                                                <Image src={estateVessel.vessel.image} />
                                                                            </div>
                                                                            <div className='vessel-item-data'>
                                                                                <div>
                                                                                    <div className='vessel-item-datafield'><strong>Chave ID:</strong>{estateVessel.vessel.identifyKey}</div>
                                                                                    <div className='vessel-item-datafield'><strong>Nome da Embarcação:</strong>{estateVessel.vessel.name}</div>
                                                                                </div>
                                                                                <div>
                                                                                    <div className='vessel-item-datafield'><strong>Ano:</strong>{estateVessel.vessel.year}</div>
                                                                                    <div className='vessel-item-datafield'><strong>Tipo de Embarcação:</strong>{estateVessel.vessel.typeVessel}</div>
                                                                                    <div className='vessel-item-datafield'><strong>Cor:</strong>{estateVessel.vessel.color}</div>
                                                                                </div>
                                                                                <div>
                                                                                    <div className="vessel-item-datafield"><strong>Observação:</strong>{estateVessel.observation}</div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="vessel-item-action">
                                                                                <TooltipMaterial className="isClickable" title="Editar">
                                                                                    <span onClick={(e) => onClick_EditEstateVessel(e, estateVessel)}>
                                                                                        <FaEdit size={18} />
                                                                                    </span>
                                                                                </TooltipMaterial>
                                                                                <TooltipMaterial className="isClickable" title="Excluir">
                                                                                    <span onClick={(e) => onClick_DeleteEstateVessel(e, index)}>
                                                                                        <FaTrash size={18} />
                                                                                    </span>
                                                                                </TooltipMaterial>
                                                                            </div>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            </fieldset>
                                                        </Container>
                                                    </Tab>}
                                                    <Tab eventKey="estate-servant" title={'Prestadores'}>
                                                        <Container fluid className="container-min">
                                                            <fieldset>
                                                                <legend className="d-flex justify-content-between align-items-center pt-2 px-2">
                                                                    <span>Listagem de Prestadores de serviços</span>
                                                                    <Button onClick={ (e) => onClick_AddServant(e) } variant="contained" color="primary">
                                                                        <AddIcon />Adicionar
                                                                    </Button>
                                                                </legend>
                                                                <ul className='servant-list'>
                                                                    {servants?.map((servant: any, index: number) => (
                                                                        <li className='servant-item' key={`servant-item-${index}`}>
                                                                            <div className='servant-item-img'>
                                                                                <Image src={servant.people?.image} />
                                                                            </div>
                                                                            <div className='servant-item-data'>
                                                                                <div>
                                                                                    <div className='servant-item-datafield'><strong>Apelido:</strong>{servant.nickname}</div>
                                                                                </div>
                                                                                <div>
                                                                                    <div className='servant-item-datafield'><strong>Nome:</strong>{servant.people ? servant.people.fullname : ''}</div>
                                                                                    <div className='servant-item-datafield'><strong>Telefone:</strong>{servant.people ? phoneMask(servant.people.phones[0].connection) : ''}</div>
                                                                                    <div className='servant-item-datafield'><strong>Idade:</strong>{servant.people ? dateToString(new Date(servant.people.birth), 'dd/mm/yyyy') : ''} - {servant.people ? idade(new Date(servant.people.birth)) : ''} anos</div>
                                                                                </div>
                                                                                <div>
                                                                                    <div className='servant-item-datafield'><strong>CPF:</strong>{servant.people ? cpfCnpjMask(servant.people.registrationPf) : ''}</div>
                                                                                </div>
                                                                                <div>
                                                                                    <div className='servant-item-datafield'><strong>Tipo de Prestador:</strong>{getServantType(servant.caste)}</div>
                                                                                </div>
                                                                            </div>
                                                                            <div className='servant-item-journeys'>
                                                                                <div className="journey-item-title">Dias de Trabalho</div>
                                                                                {servant.journey?.map((daily: any, index: number) => (
                                                                                    <div className="journey-item-data" key={`journey-item-${index}`}>
                                                                                        <span className='journey-item-datafield'>{display.label[toLowerCase(daily.name)]}</span>
                                                                                        <span className='journey-item-datafield'>{daily.entry}</span>
                                                                                        <span className='journey-item-datafield'>{daily.exit}</span>
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                            <div className="servant-item-action">
                                                                                <TooltipMaterial className="isClickable" title="Editar">
                                                                                    <span onClick={(e) => onClick_EditServant(e, servant)}>
                                                                                        <FaEdit size={18} />
                                                                                    </span>
                                                                                </TooltipMaterial>
                                                                                <TooltipMaterial className="isClickable" title="Excluir">
                                                                                    <span onClick={(e) => onClick_DeleteServant(e, index)}>
                                                                                        <FaTrash size={18} />
                                                                                    </span>
                                                                                </TooltipMaterial>
                                                                            </div>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            </fieldset>
                                                        </Container>
                                                    </Tab>
                                                    <Tab eventKey="estate-visitor" title={'Visitantes'}>
                                                        <Container fluid className="container-min">
                                                            <fieldset>
                                                                <legend className="d-flex justify-content-between align-items-center pt-2 px-2">
                                                                    <span>Listagem de Visitantes</span>
                                                                    <Button onClick={ (e) => onClick_AddVisitor(e) } variant="contained" color="primary">
                                                                        <AddIcon />Adicionar
                                                                    </Button>
                                                                </legend>
                                                                <ul className='visitor-list'>
                                                                    {visitors?.map((visitor: any, index: number) => (
                                                                        <li className='visitor-item' key={`visitor-item-${index}`}>
                                                                            <div className='visitor-item-img'>
                                                                                <Image src={visitor.people?.image} />
                                                                            </div>
                                                                            <div className='visitor-item-data'>
                                                                                <div>
                                                                                    <div className='visitor-item-datafield'><strong>Apelido:</strong>{visitor.nickname}</div>
                                                                                </div>
                                                                                <div>
                                                                                    <div className='visitor-item-datafield'><strong>Nome:</strong>{visitor.people ? visitor.people.fullname : ''}</div>
                                                                                    <div className='visitor-item-datafield'><strong>Telefone:</strong>{visitor.people ? phoneMask(visitor.people.phones[0].connection) : ''}</div>
                                                                                    <div className='visitor-item-datafield'><strong>Idade:</strong>{visitor.people ? dateToString(new Date(visitor.people.birth), 'dd/mm/yyyy') : ''} - {visitor.people ? idade(new Date(visitor.people.birth)) : ''} anos</div>
                                                                                </div>
                                                                                <div>
                                                                                    <div className='visitor-item-datafield'><strong>CPF:</strong>{visitor.people ? cpfCnpjMask(visitor.people.registrationPf) : ''}</div>
                                                                                </div>
                                                                            </div>
                                                                            <div className='visitor-item-recurrences'>
                                                                                <div className="recurrence-item-title">Últimas Visitas</div>
                                                                                {visitor.recurrences?.map((recurrence: any, index: number) => (
                                                                                    <div className="recurrence-item-data" key={`recurrence-item-${index}`}>
                                                                                        <div className='recurrence-item-datafield'>{dateToString(recurrence.entry, 'dd/mm/yyyy HH:MM:ss')}</div>
                                                                                        <div className='recurrence-item-datafield'>{dateToString(recurrence.exit, 'dd/mm/yyyy HH:MM:ss')}</div>
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                            <div className="visitor-item-action">
                                                                                <TooltipMaterial className="isClickable" title="Editar">
                                                                                    <span onClick={(e) => onClick_EditVisitor(e, visitor)}>
                                                                                        <FaEdit size={18} />
                                                                                    </span>
                                                                                </TooltipMaterial>
                                                                                <TooltipMaterial className="isClickable" title="Excluir">
                                                                                    <span onClick={(e) => onClick_DeleteVisitor(e, index)}>
                                                                                        <FaTrash size={18} />
                                                                                    </span>
                                                                                </TooltipMaterial>
                                                                            </div>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            </fieldset>
                                                        </Container>
                                                    </Tab>
                                                </Tabs>
                                            </Container>
                                        </Col>
                                    </Row>
                                </Form>
                            </Card.Body>
                            <Card.Footer className="text-right">
                                <Button className="me-2" onClick={ (e) => onClick_CancelEstate(e) } variant="contained" color="secondary">{display.buttom.cancel}</Button>
                                {!props.viewOnly && <Button onClick={ (e) => onClick_SaveEstate(e) } disabled={sending} variant="contained" color="primary">
                                    { sending ? <Spinner className="me-2" as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : <FaSave className="me-2" size={22} /> } {' '}
                                    {display.buttom.save}
                                </Button>}
                            </Card.Footer>
                        </Card>
                    </Col>
                </Row>
            </Container>
        );
    } // viewCadastreForm

    return (
        <div className="page">
            <CondominiumHeader title={'Imóvel'} description={''} />
            { viewCadastreForm() }
            {showResident && (
                <ResidentCadastreModal 
                    isEdit={isEditForm}
                    show={showResident}
                    record={resident}

                    onSubmitModal={(event: any, record: any) => { 
                        event.preventDefault();

                        const exist = residents.map((resident: any) => (resident.people.registrationPf === record.people.registrationPf))[0];
                        let updateResidents = [];
                        if (!exist) {
                            for (let i = 0; i < residents.length; i++) {
                                updateResidents.push(residents[i]);
                            }
                            updateResidents.push(record);
                        } else {
                            updateResidents = residents.map((resident: any) => {
                                if (resident.people.registrationPf === record.people.registrationPf)
                                    return {...residents, record };
                                return {...residents, resident };
                            });
                        }
                        setResidents(updateResidents);
                        setShowResident(false);
                    }}
                    onCancelModal={(event: any) => { 
                        event.preventDefault();

                        setShowResident(false);
                    }}
                />
            )}
            {showVehicle && (
                <VehicleCadastreModal 
                    isEdit={isEditForm}
                    show={showVehicle}
                    record={vehicle}

                    onSubmitModal={(event: any, record: any) => { 
                        event.preventDefault();

                        const exist = vehicles.map((vehicle: any) => (vehicle.people.registrationPf === record.people.registrationPf))[0];
                        let updateVehicles = [];
                        if (!exist) {
                            for (let i = 0; i < vehicles.length; i++) {
                                updateVehicles.push(vehicles[i]);
                            }
                            updateVehicles.push(record);
                        } else {
                            updateVehicles = vehicles.map((vehicle: any) => {
                                if (vehicle.people.registrationPf === record.people.registrationPf)
                                    return {...vehicles, record };
                                return {...vehicles, vehicle };
                            });
                        }
                        setVehicles(updateVehicles);
                        setShowVehicle(false);
                    }}
                    onCancelModal={(event: any) => { 
                        event.preventDefault();

                        setShowVehicle(false);
                    }}
                />
            )}
            {showServant && (
                <ServantCadastreModal 
                    isEdit={isEditForm}
                    show={showServant}
                    record={servant}

                    onSubmitModal={(event: any, record: any) => { 
                        event.preventDefault();

                        const exist = servants.map((servant: any) => (servant.people.registrationPf === record.people.registrationPf))[0];
                        let updateServants = [];
                        if (!exist) {
                            for (let i = 0; i < servants.length; i++) {
                                updateServants.push(servants[i]);
                            }
                            updateServants.push(record);
                        } else {
                            updateServants = servants.map((servant: any) => {
                                if (servant.people.registrationPf === record.people.registrationPf)
                                    return {...servants, record };
                                return {...servants, servant };
                            });
                        }
                        setServants(updateServants);
                        setShowServant(false);
                    }}
                    onCancelModal={(event: any) => { 
                        event.preventDefault();

                        setShowServant(false);
                    }}
                />
            )}
            {showVisitor && (
                <VisitorCadastreModal 
                    isEdit={isEditForm}
                    show={showVisitor}
                    record={visitor}

                    onSubmitModal={(event: any, record: any) => { 
                        event.preventDefault();

                        const exist = visitors.map((visitor: any) => (visitor.people.registrationPf === record.people.registrationPf))[0];
                        let updateVisitors = [];
                        if (!exist) {
                            for (let i = 0; i < visitors.length; i++) {
                                updateVisitors.push(visitors[i]);
                            }
                            updateVisitors.push(record);
                        } else {
                            updateVisitors = visitors.map((visitor: any) => {
                                if (visitor.people.registrationPf === record.people.registrationPf)
                                    return {...visitors, record };
                                return {...visitors, visitor };
                            });
                        }
                        setVisitors(updateVisitors);
                        setShowVisitor(false);
                    }}
                    onCancelModal={(event: any) => { 
                        event.preventDefault();

                        setShowVisitor(false);
                    }}
                />
            )}
            {showEstateVessel && (
                <EstateVesselCadastreModal 
                    isEdit={isEditForm}
                    show={showEstateVessel}
                    record={estateVessel}

                    onSubmitModal={(event: any, record: any) => { 
                        event.preventDefault();

                        const exist = estateVessels.map((estateVessel: any) => (estateVessel.vessel.registration === record.vessel.registration))[0];
                        let updateVessels = [];
                        if (!exist) {
                            for (let i = 0; i < estateVessels.length; i++) {
                                updateVessels.push(estateVessels[i]);
                            }
                            updateVessels.push(record);
                        } else {
                            updateVessels = estateVessels.map((estateVessel: any) => {
                                if (estateVessel.vessel.registration === record.vessel.registrationf)
                                    return {...estateVessels, record };
                                return {...estateVessels, estateVessel };
                            });
                        }
                        setEstateVessels(updateVessels);
                        setShowEstateVessel(false);
                    }}
                    onCancelModal={(event: any) => { 
                        event.preventDefault();

                        setShowEstateVessel(false);
                    }}
                />
            )}
        </div>
    );

}

export default EstateAllCondominiumForm;
